// extracted by mini-css-extract-plugin
export default {"root":"kbNUxi5qVXWOSM8tY4cu","label":"PZX2sVDzc7GyVTzBY9gZ undefined","value":"YJ8mz01j8kdTa98th4en"};